import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35a19322"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "検討", -1))
const _hoisted_3 = { class: "dialog-form-area" }
const _hoisted_4 = { class: "dialog-form-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-form-item-label" }, "エンジン", -1))
const _hoisted_6 = { class: "dialog-form-item-unit" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("select", {
              ref: "engineSelect",
              class: "engine-select",
              size: "1",
              value: _ctx.defaultValue
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.engines, (engine) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: engine.uri,
                  value: engine.uri
                }, _toDisplayString(engine.name), 9, _hoisted_8))
              }), 128))
            ], 8, _hoisted_7)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onStart()))
        }, "検討開始"),
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancel()))
        }, "キャンセル")
      ])
    ], 512)
  ]))
}